import { createUseStyles } from 'react-jss'
import { trafficRedDark } from '../../../styles/const/colors'

const useStyles = createUseStyles({
  exceptedFile: {
    borderColor: trafficRedDark,
    textAlign: 'left'
  }
})

export default useStyles
